// extracted by mini-css-extract-plugin
module.exports = {"DateWrapper":"date_DateWrapper__LmvH0"};